export default "__VITE_ASSET__7u7vzEvy__"